import React from "react";

const StatsOverview = ({ activeJobs, notPrintedJob, printedJob }) => {
  return (
    <div className="row mb-4 g-3">
      <div className="col-md-4">
        <div className="card shadow-sm h-100 border-0 bg-success bg-opacity-10">
          <div className="card-body text-center py-3">
            <i className="bi bi-lightning-charge-fill fs-4 text-success mb-2"></i>
            <h6 className="text-uppercase text-muted mb-2">Active Jobs</h6>
            <h2 className="mb-0 text-success">{activeJobs.length}</h2>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card shadow-sm h-100 border-0 bg-warning bg-opacity-10">
          <div className="card-body text-center py-3">
            <i className="bi bi-clock-fill fs-4 text-purple mb-2"></i>
            <h6 className="text-uppercase text-muted mb-2">Awaiting Print Jobs</h6>
            <h2 className="mb-0 text-primary">{notPrintedJob.length}</h2>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card shadow-sm h-100 border-0 bg-purple bg-opacity-10">
          <div className="card-body text-center py-3">
            <i className="bi bi-check-circle-fill fs-4 text-primary mb-2"></i>
            <h6 className="text-uppercase text-muted mb-2">Printed Jobs</h6>
            <h2 className="mb-0 text-purple">
              {printedJob.length}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;
